export { templateEditRoute } from './route'
